import React, { Fragment, useEffect } from 'react'
import { getColor } from '../../Redux/Action/color';
import { useDispatch } from 'react-redux';

const HeaderDesignCreationPlainJacket = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        const pageSize = 100;
      const status = "true";
      dispatch(getColor({status, pageSize}));
    }, [dispatch]);
    return (
        <Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12 dashBoard">
                        <h2>Design Creation</h2>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default HeaderDesignCreationPlainJacket
